import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { FleetStrip } from "@/components/FleetStrip";
import { Industries } from "@/components/Industries";
import { Coverage } from "@/components/Coverage";
import { WhyPartner } from "@/components/WhyPartner";
import { Founder } from "@/components/Founder";
import { Quotes } from "@/components/Quotes";
import { Faq } from "@/components/Faq";
import { EstimateTool } from "@/components/EstimateTool";
import { CtaSection } from "@/components/CtaSection";
import { Footer } from "@/components/Footer";
import { ChatWidget } from "@/components/ChatWidget";

export default function Home() {
  return (
    <main className="bg-[#080C14]">
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <FleetStrip />
      <Industries />
      <Coverage />
      <WhyPartner />
      <Founder />
      <Quotes />
      <Faq />
      <EstimateTool />
      <CtaSection />
      <Footer />
      <ChatWidget />
    </main>
  );
}
